import { buildFilters, type SieveFilterModel } from './filter';
import { buildSort } from './sort';

export function buildSieveUrl(
	filters: SieveFilterModel[],
	sortColumn: string,
	sortDirection: string,
	pageSize: number = 10,
	page: number = 1,
	queryStringFilters?: string
): string {
	const builtFilters = Array.isArray(filters) ? buildFilters(filters).join(',') : filters;
	return `filters=${queryStringFilters ? encodeURIComponent(queryStringFilters) : builtFilters ? encodeURIComponent(builtFilters) : ''}&${buildSort(
		sortColumn,
		sortDirection
	)}&page=${page}&pageSize=${pageSize}`;
}
